// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__iIlbe","wrapperContainer":"Modal_wrapperContainer__o28E3","iconsContainer":"Modal_iconsContainer__QF0+E","clipboard":"Modal_clipboard__Yhfjt"};